var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.09375,
    width: 21.2131,
    height: 21.2131,
    rx: 10.6066,
    fill: "#60EC2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1446 11.9341V9.0489L12.681 10.4917L10.1446 11.9341ZM15.7863 8.14066C15.6717 7.7197 15.3482 7.3942 14.9369 7.27901L14.9282 7.27707C13.895 7.1457 12.7001 7.07064 11.4874 7.07064C11.3641 7.07064 11.2412 7.07128 11.1185 7.0729L11.1373 7.07258C11.0331 7.07128 10.9105 7.07031 10.7872 7.07031C9.5745 7.07031 8.37893 7.14538 7.20537 7.29066L7.3458 7.27642C6.92613 7.39388 6.60257 7.71906 6.4903 8.1316L6.48835 8.14001C6.35893 8.82241 6.28516 9.6077 6.28516 10.4101C6.28516 10.4386 6.28516 10.4671 6.28548 10.4952V10.4907C6.28548 10.5146 6.28516 10.5431 6.28516 10.5716C6.28516 11.374 6.35925 12.159 6.50065 12.9203L6.48835 12.8414C6.6029 13.2623 6.92646 13.5878 7.33771 13.703L7.34644 13.705C8.37958 13.8363 9.5745 13.9114 10.7872 13.9114C10.9102 13.9114 11.0331 13.9108 11.1561 13.9091L11.1373 13.9095C11.2415 13.9108 11.3645 13.9117 11.4874 13.9117C12.7004 13.9117 13.8957 13.8367 15.0693 13.6914L14.9288 13.7056C15.3488 13.5885 15.6724 13.263 15.785 12.8504L15.7869 12.842C15.916 12.1596 15.9898 11.3744 15.9898 10.5722C15.9898 10.5438 15.9898 10.5153 15.9895 10.4871V10.4913C15.9895 10.4674 15.9898 10.4389 15.9898 10.4105C15.9898 9.60802 15.9157 8.82305 15.7743 8.06171L15.7863 8.14066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9a8dccb44a62480777834d2bd5a9acdb.svg";
export { ForwardRef as ReactComponent };